import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class GetCityList extends Event {
    eventName = 'oms_getCityList';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get city list for given client id
     * 
     * @param {string} data.country -  country code given for client
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let countryCode = data.country;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let multiCallKey = (data.multi_call_key) ? data.multi_call_key : 'city_list';
        
        // request data
        data.endPoint = application_settings.endPoints.cityList;
        data.multi_call_key = multiCallKey;
        data.data = {
            client_id: clientId,
            country: countryCode
        };
    
        this.sendRequest(data, function (response) {
            if (response) {
                //add data to storage
                let cityList = new LocalStorage.CityList(clientId + '_' + countryCode);
                cityList.setData(response);

                //format response data
                let data = thisObj.formatResponseData(response);
                data.type = response?.data?.type;

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
        
    }
}

export default GetCityList;